import { isEmpty } from '@witmetrics/utils/misc';
import { API } from '@/api';

export const classes = {
  dialog: 'w-[98vw] max-w-[650px] min-w-[350px]',
  body: 'w-full max-h-[80vh] min-h-[100px] pt-2 pb-12 overflow-auto',
};

export async function fetchToken(fileId: number) {
  const { results } = await API.Files.fetchFileVersions(fileId, {
    pagination: { page: 1, pageSize: 1 },
  });
  if (isEmpty(results)) throw Error('File version not found');
  return (await API.Files.createFileVersionToken(results[0].id)).token;
}
